import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppLayout from "./components/AppLayout";
import Placeholder from "./components/Placeholder";
import Settings from "./components/Settings";
import CatalogPage from "./pages/CatalogPage";
import OAuthCodePage from "./pages/OAuthCodePage";
import RegisterPage from "./pages/RegisterPage";
import SpotsPage from "./pages/SpotsPage";
import SpotDetailPage from "./pages/SpotDetailPage";
import BillingPage from "./pages/BillingPage";
import DeferredPaymentsPage from "./pages/DeferredPaymentsPage";

const App = () => {
  if (window.top) {
    window.top.postMessage({ hideSpinner: true }, "*");
  }
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="catalog" replace />} />
        <Route path="catalog" element={<CatalogPage />} />
        <Route path="settings" element={<Settings />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="deferred-uzqr" element={<DeferredPaymentsPage />} />
        <Route
          path="balance-history"
          element={<Navigate to="/billing" replace />}
        />
        <Route path="register" element={<RegisterPage />} />
        <Route path="onboarding" element={<RegisterPage />} />
        <Route path="spots" element={<SpotsPage />} />
        <Route path="spots/:spotId" element={<SpotDetailPage />} />
        <Route
          path="dashboard"
          element={
            <section className="bodyContainer">
              <Placeholder title="Дашборд" icon="dashboard" />
            </section>
          }
        />
        <Route
          path="help"
          element={
            <section className="bodyContainer">
              <Placeholder title="Помощь" icon="help" />
            </section>
          }
        />
        <Route path=":code" element={<OAuthCodePage />} />
      </Route>
    </Routes>
  );
};

export default App;
